import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.column}>
          <h4>Sobre</h4>
          <Link to="/pontos-turisticos">Pontos Turísticos</Link>
          <Link to="/eventos">Eventos</Link>
          <Link to="/historia">História</Link>
          <Link to="/poesias">Poesias</Link>
        </div>

        <div className={styles.column}>
          <h4>Contato</h4>
          <a href="mailto:culturaturismo@saojosedoegito.pe.gov.br">culturaturismo@saojosedoegito.pe.gov.br</a>
          <a href="tel:+5587933003680">(87) 93300-3680</a>
        </div>

        <div className={styles.column}>
          <h4>Redes Sociais</h4>
          <a href="https://www.instagram.com/terradapoesia.sje?igsh=MWoybGt0MnBvajJocw==" target="_blank" rel="noopener noreferrer">Instagram</a>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>&copy; {new Date().getFullYear()} Cidade de São José do Egito. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
